export default __webpack_public_path__ + "static/pic_meeting-a8b0c250ffa73bd284c972058a8e62e5.svg";